<template>
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" :width="width" :height="height" viewBox="0 0 32 32">
        <path :fill="`url(#${gradientId})`" d="M7.583 5.991h16.834c.378 0 .733.18.955.483l4.515 6.163a.583.583 0 0 1-.044.743l-13.41 14.422a.594.594 0 0 1-.867 0L2.156 13.38a.583.583 0 0 1-.043-.743l4.515-6.163c.222-.303.577-.483.955-.483Z"></path>
        <defs>
            <linearGradient :id="gradientId" x1="-1.826" x2="31.82" y1="2.063" y2="3.314" gradientUnits="userSpaceOnUse">
                <stop stop-color="#E7407C"></stop>
                <stop offset="1" stop-color="#EF805E"></stop>
            </linearGradient>
        </defs>
    </svg>
</template>

<script>
export default {
    props: {
        width: {
            type: String,
            default: '32',
        },
        height: {
            type: String,
            default: '32',
        },
    },
    computed: {
        gradientId() {
            return `gem-filled-gradient-${this._uid}`;
        },
    },
}
</script>
